// "Apri nel navigatore": lascia che sia il dispositivo a scegliere l'app di mappe/navigazione.
// - Android  -> schema geo: (il sistema apre l'app mappe predefinita o mostra il selettore)
// - iOS      -> Apple Maps (mappa predefinita del dispositivo) via maps.apple.com
// - Desktop / fallback -> servizio mappe web (Google Maps). Google Maps NON è imposto su mobile.
// Nessuna mappa integrata in YouPAM: solo un link esterno di navigazione.
export const navUrl = (address) => {
  const a = (address || "").trim();
  if (!a) return null;
  const q = encodeURIComponent(a);
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return `https://maps.apple.com/?q=${q}`;
  if (/Android/i.test(ua)) return `geo:0,0?q=${q}`;
  return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
};
